import { useAdfoxStore } from '~/store/adfox';
import { watch } from 'vue';
import { isRetina } from '~/utils';

export function useAdfoxWindowAssign() {
  const adfoxStore = useAdfoxStore();

  watch(
    () => adfoxStore.currentAdfox,
    (val) => {
      if (import.meta.server) return;

      Object.assign(window, {
        ...val,
        lh_adfox_rtn: isRetina(),
      });
    },
    { immediate: true },
  );
}
